module.exports = __webpack_public_path__ + "static/media/saraBook.a6a45605.jpg";